import React from 'react';
import './App.css';
import '../../styles/main.scss';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../../layouts/ProtectedRoute/ProtectedRoute';
import { MainPage } from '../../pages';
import { LandingPage } from '../../pages/Landing/LandingPage';
import { AboutPage } from '../../pages/About/AboutPage';
import { Navigate } from 'react-router-dom';
import { DesktopAuthPage } from '../../pages/DesktopAuth/DesktopAuthPage';
import { OAuthCallback } from '../../pages/OAuthCallback/OAuthCallback';
import { OAuthConsentPage } from '../../pages/OAuthConsent/OAuthConsentPage';
import { LoginPage } from '../../pages/Login/LoginPage';
import { OfferPage } from '../../pages/Offer/OfferPage';
import { PrivacyPage } from '../../pages/Privacy/PrivacyPage';
import { ConsentPage } from '../../pages/Consent/ConsentPage';
import { CrossBorderConsentPage } from '../../pages/CrossBorderConsent/CrossBorderConsentPage';
import { RefundPage } from '../../pages/Refund/RefundPage';
import { RightsHoldersPage } from '../../pages/RightsHolders/RightsHoldersPage';
import { ContactsPage } from '../../pages/Contacts/ContactsPage';
import { OnboardingPage } from '../../pages/Onboarding/OnboardingPage';
import { ModalWindowContainer } from '../../containers/ModalWindow/ModalWindowContainer';
import { CookieNotice } from '../CookieNotice/CookieNotice';

function App() {
  return (
    <>
      <Routes>
      <Route path='/' element={<LandingPage />} />
      <Route path='/about' element={<AboutPage />} />
      <Route path='/offer' element={<OfferPage />} />
      <Route path='/privacy' element={<PrivacyPage />} />
      <Route path='/consent' element={<ConsentPage />} />
      <Route path='/cross-border-consent' element={<CrossBorderConsentPage />} />
      <Route path='/refund' element={<RefundPage />} />
      <Route path='/rights-holders' element={<RightsHoldersPage />} />
      <Route path='/contacts' element={<ContactsPage />} />
      <Route path='/onboarding' element={<ProtectedRoute element={OnboardingPage} />} />
      <Route path='/desktop-auth' element={<DesktopAuthPage />} />
      <Route path='/oauth/callback' element={<OAuthCallback />} />
      <Route path='/oauth-consent' element={<OAuthConsentPage />} />
      <Route path='/login' element={<LoginPage />} />
      <Route path='/app/*' element={<ProtectedRoute element={MainPage} />} />
      <Route path='/signin' element={<Navigate to="/login" replace />} />
      <Route path='/signup' element={<Navigate to="/login" replace />} />
      </Routes>
      <ModalWindowContainer />
      <CookieNotice />
    </>
  );
}

export default App;
